import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按类型快速浏览，精准定位你想看的电影
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexData.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group bg-background-100 rounded-xl p-5 border border-background-200/70 text-center cursor-pointer no-underline hover:border-primary-300/50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 mx-auto mb-3 transition-colors duration-300">
                <i className="ri-movie-line text-primary-600 group-hover:text-background-50 text-xl transition-colors duration-300"></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-sm mb-1">{item.title}</h3>
              <p className="text-foreground-400 text-xs mb-1">{item.count}</p>
              <p className="text-foreground-500 text-xs">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}